import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight, Megaphone, Newspaper, BadgeCheck, Layers } from "lucide-react";

const SERVICES = [
  {
    icon: Megaphone,
    title: "PR Distribution to UAE Journalists",
    desc: "We pitch your story directly to journalists and editors covering the UAE market, in Arabic and English. Earned coverage in the outlets your audience reads.",
    to: "/services/journalist-outreach",
    cta: "Explore Journalist Outreach",
  },
  {
    icon: Newspaper,
    title: "Gulf Newswire Distribution",
    desc: "Syndicate your press release across Gulf newswire networks covering the UAE and wider GCC, with same-day submission and a full pickup report. Regional newswires from $475.",
    to: "/services/newswire-distribution",
    cta: "Browse Newswires",
  },
  {
    icon: BadgeCheck,
    title: "UAE Guaranteed Placements",
    desc: "Choose the exact UAE publication. We guarantee it publishes, or you get a full refund. UAE titles from $100, flagship names from $600, with pricing and turnarounds shown before you pay.",
    to: "/services/guaranteed-placements",
    cta: "View Guaranteed Placements",
  },
  {
    icon: Layers,
    title: "UAE Curated Packages",
    desc: "Pre-built bundles designed for UAE launches and announcements, priced below buying the channels separately.",
    to: "/packages",
    cta: "See Curated Packages",
  },
];

export default function UaeServices() {
  return (
    <section className="py-12 lg:py-16 bg-canvas">
      <Container>
        <SectionHeading
          tag="WHAT WE OFFER"
          title="Every channel for the UAE, in one place."
          subtitle="Whether you need earned media, syndicated reach, guaranteed placements, or a curated mix, we have a solution built for the UAE market."
        />

        <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              className="group bg-white border border-border rounded-xl p-7 lg:p-8 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 mb-5">
                <s.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-xl font-bold text-bone mb-2">{s.title}</h3>
              <p className="text-sm text-steel leading-relaxed mb-5">{s.desc}</p>
              <Link
                to={s.to}
                className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors mt-auto"
              >
                {s.cta} <ArrowRight className="ml-1.5 w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}